export default () => ({
    catalog: null,
    catalogFetchedAt: null,
    config: null,
    dashboard: null,
    dashboardFetchedAt: null,
    period: null,
    loading: false,
    saving: false,
    error: null
})
